import { cn } from "@/lib/utils";
import { LucideIcon } from "lucide-react";
import React from "react";

interface PageHeaderProps {
    title: string | React.ReactNode;
    description?: string | React.ReactNode;
    icon?: LucideIcon;
    actions?: React.ReactNode;
    children?: React.ReactNode; // For control bars/filters/extra content below the header
    className?: string;
}

export function PageHeader({
    title,
    description,
    icon: Icon,
    actions,
    children,
    className,
}: PageHeaderProps) {
    return (
        <div className={cn("flex flex-col gap-6 mb-8", className)}>
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                <div className="space-y-1">
                    <div className="flex items-center gap-3">
                        {Icon && <Icon className="h-6 w-6 text-muted-foreground" />}
                        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground">
                            {title}
                        </h1>
                    </div>
                    {description && (
                        <div className="text-muted-foreground text-sm max-w-2xl leading-relaxed">
                            {description}
                        </div>
                    )}
                </div>

                {actions && (
                    <div className="flex items-center gap-3 self-start md:self-auto">
                        {actions}
                    </div>
                )}
            </div>

            {children && (
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full">
                    {children}
                </div>
            )}
        </div>
    );
}
